/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ProductionQaCheck } from '../../models/production-qa-check';

export interface GetSetupProductionQaChecks$Params {
  productionOrderId: number;
}

export function getSetupProductionQaChecks(http: HttpClient, rootUrl: string, params: GetSetupProductionQaChecks$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ProductionQaCheck>>> {
  const rb = new RequestBuilder(rootUrl, getSetupProductionQaChecks.PATH, 'get');
  if (params) {
    rb.path('productionOrderId', params.productionOrderId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<ProductionQaCheck>>;
    })
  );
}

getSetupProductionQaChecks.PATH = '/api/v1/QaCheck/{productionOrderId}/GetSetupProductionQaChecks';
